/* eslint-disable */

(function ($) {
    $.widget("ep.forms_datepicker", {
        options: {
            culture: '',
            buttonImage: '',
            resources: {
                buttonText:''
            }
        },

        _create: function () {
            var element = this.element;

            var options = $.extend({}, this.options);

            // Create date picker

            $.extend(options, {
                buttonText: this.options.resources.buttonText,
                showOn: "button",
                buttonImage: this.options.buttonImage,
                buttonImageOnly: true,
                onSelect: function () {
                    element.parents('form').validate().element(element);
                },
                calendarClass: "dialog-dp"
            });

            element.datepicker(options);
        },

        getDate: function () {
            return this.element.datepicker('getDate');
        },

        setDate: function (date) {
            return this.element.datepicker('setDate', date);
        },

        destroy: function () {
            this.element.datepicker("hide");
            this.element.datepicker('destroy');

            $.Widget.prototype.destroy.call(this);
        }
    });

})(jQuery);

/* eslint-enable */